import { useLayoutEffect, useRef, useState } from 'react';
import { useResizeObserver } from 'usehooks-ts';
function useTagListLayout(layoutArgs) {
    const { linesCollapsed, initialFirstOverflowIndex, initialContainerHeight } = layoutArgs ?? {};
    const [overflowPos, setOverflowPos] = useState();
    const [firstOverflowIndex, setFirstOverflowIndex] = useState(undefined);
    const [containerHeight, setContainerHeight] = useState(undefined);
    const refContainer = useRef(null);
    const refItems = useRef([]);
    const refOverflow = useRef(null);
    const [hasBeenInitialized, setHasBeenInitialized] = useState(false);
    const { width: containerWidth } = useResizeObserver({
        ref: refContainer,
        box: 'border-box'
    });
    const { width: overflowWidth, height: overflowHeight } = useResizeObserver({
        ref: refOverflow,
        box: 'border-box'
    });
    useLayoutEffect(() => {
        if (typeof linesCollapsed === 'undefined') {
            setOverflowPos(undefined);
            setFirstOverflowIndex(undefined);
            setContainerHeight(undefined);
            return;
        }
        const { current: containerElem } = refContainer;
        const { current: itemElems } = refItems;
        if (typeof containerWidth !== 'undefined' &&
            containerElem &&
            itemElems.length > 0 &&
            itemElems.every(Boolean)) {
            let newFirstOverflowIndex;
            let walkedLines = 0;
            const containerRect = containerElem.getBoundingClientRect();
            for (let i = 1, col = 0, prevRect = itemElems[0].getBoundingClientRect(), currentRect = null; i < itemElems.length; ++i, ++col, prevRect = currentRect) {
                currentRect = itemElems[i].getBoundingClientRect();
                if (currentRect.left < prevRect.right) {
                    walkedLines += 1;
                    col = 0;
                }
                if (typeof overflowWidth !== 'undefined' && walkedLines === linesCollapsed - 1) {
                    if (currentRect.left + overflowWidth > containerRect.right) {
                        newFirstOverflowIndex = col === 0 ? i : i - 1;
                        break;
                    }
                }
                if (walkedLines >= linesCollapsed) {
                    newFirstOverflowIndex = typeof overflowWidth !== 'undefined' ? i - 1 : i;
                    break;
                }
            }
            if (typeof newFirstOverflowIndex === 'undefined') {
                setOverflowPos(undefined);
                setFirstOverflowIndex(undefined);
                setContainerHeight(undefined);
            }
            else {
                const { bottom: lastItemBottom } = itemElems[newFirstOverflowIndex - 1].getBoundingClientRect();
                const { top: firstOverflowTop, left: firstOverflowLeft } = itemElems[newFirstOverflowIndex].getBoundingClientRect();
                setOverflowPos(typeof overflowWidth !== 'undefined'
                    ? {
                        top: firstOverflowTop - containerRect.top,
                        left: firstOverflowLeft - containerRect.left
                    }
                    : undefined);
                setFirstOverflowIndex(newFirstOverflowIndex);
                setContainerHeight(typeof overflowHeight !== 'undefined'
                    ? firstOverflowTop + overflowHeight - containerRect.top
                    : lastItemBottom - containerRect.top);
            }
            setHasBeenInitialized(true);
        }
    }, [linesCollapsed, containerWidth, overflowWidth, overflowHeight]);
    return {
        refContainer,
        refOverflow,
        refItems,
        hasBeenInitialized,
        firstOverflowIndex: hasBeenInitialized ? firstOverflowIndex : initialFirstOverflowIndex,
        overflowTop: overflowPos?.top,
        overflowLeft: overflowPos?.left,
        containerHeight: hasBeenInitialized ? containerHeight : initialContainerHeight
    };
}
export default useTagListLayout;
//# sourceMappingURL=useTagListLayout.js.map